import { useCallback } from "react"
import { reportListData } from "Pages/Main/Home/@signals"

export default function useReportsHomeData() {

	const setReportData = useCallback((newData = {}) => {
		let targetIdx = null
		const allReports = reportListData.value.map(item => item)
		const myReport = allReports.filter((item, idx) => {
			const same = item.idReport === newData?.idReport
			if (same) targetIdx = idx
			return same
		})[0]

		if (myReport)
			allReports[targetIdx] = { ...myReport, ...newData }
		else
			allReports.unshift(newData)
		reportListData.value = allReports
	}, [])

	return { setReportData }
}